/* eslint-disable @typescript-eslint/naming-convention */
import { Location } from "@angular/common";
import { AfterContentChecked, ChangeDetectorRef, Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatSidenav } from "@angular/material/sidenav";
import { Event, NavigationEnd, Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { AuthenticationService } from "../../core/authentication/authentication.service";
import { LoadingService } from "../../core/loader/loading.service";
import { ViewAsService } from "../../shared/components/view-as/view-as.service";
import { UserInfo } from "../../shared/types/user-info";

@Component({
  selector: "app-portal",
  templateUrl: "./portal.component.html",
  styleUrls: ["./portal.component.css"],
})
export class PortalComponent implements OnInit, AfterContentChecked {
  @ViewChild("sidenav") sidenav: MatSidenav;

  public history: string[] = [];
  defaultLogo = "../../../assets/ChannelWorks-Logo.png";
  currentUser: UserInfo;
  ticketForm: FormGroup;
  assetForm: FormGroup;
  companyOrPartner: string;
  submitted = false;
  goBack: boolean;
  loading$ = this.loader.loading$;
  logo: string | File;
  environment = environment;
  showSettingsDropdown = false;
  timedOutCloser;
  triggerMenu: any;

  constructor(
    private authenticationService: AuthenticationService,
    private viewAsService: ViewAsService,
    private formBuilder: FormBuilder,
    public router: Router,
    public location: Location,
    public loader: LoadingService,
    private changeDetector: ChangeDetectorRef,
    private ren: Renderer2,
  ) {
    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  get ticketF() {
    return this.ticketForm.controls;
  }

  get assetF() {
    return this.assetForm.controls;
  }

  ngOnInit(): void {
    this.currentUser = this.authenticationService.currentUserInfo;
    this.logo = this.getLogo();
    this.ticketForm = this.formBuilder.group({
      Title: ["", Validators.required],
      Description: ["", Validators.required],
      companyPartner: [this.companyOrPartner, Validators.required],
      TicketType: ["", Validators.required],
      AssetId: ["", Validators.required],
      Location: ["", Validators.required],
      TicketCategoryNameOrId: ["", Validators.required],
      TicketTypeNameOrId: [this.companyOrPartner + " Quotes", Validators.required],
    });
    this.assetForm = this.formBuilder.group({
      TicketType: ["", Validators.required],
      Identifier: ["", Validators.required],
      Name: ["", Validators.required],
      Description: ["", Validators.required],
      companyPartner: [this.companyOrPartner, Validators.required],
    });
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  myAccount(): void {
    this.router.navigate(["/profile"]);
    this.sidenav.close();
  }

  addUser(): void {
    this.router.navigate(["/users/create"]);
  }

  addAsset(): void {
    this.router.navigate(["/assets/create"]);
  }

  addCompany(): void {
    this.router.navigate(["/companies/create"]);
  }

  addContract(): void {
    this.router.navigate(["/contracts/create"]);
  }

  addQuote(): void {
    this.router.navigate(["/quotes/create"]);
  }

  addLocation(): void {
    this.router.navigate(["/locations/create"]);
  }

  addPartner(): void {
    this.router.navigate(["/partners/create"]);
  }

  addMaintenanceProvider(): void {
    this.router.navigate(["/maintenance-providers/create"]);
  }

  addInternalProvider(): void {
    this.router.navigate(["/internal-providers/create"]);
  }

  addTicket(): void {
    this.router.navigate(["/tickets/create"]);
  }

  addConfigurableOption(): void {
    this.router.navigate(["/configurable-options/create"]);
  }

  getLogo(): string {
    const { company, partner } = this.viewAsService.getViewAs() || this.currentUser;
    const { selectedCompany, companies } = this.currentUser;

    // Set company/partner logo depending on the case
    let logo = null;

    if (selectedCompany?.logo) {
      logo = selectedCompany.logo;
    } else if (company?.logo && !companies?.length) {
      logo = company.logo;
    } else if (company?.partner?.logo) {
      logo = company?.partner.logo;
    } else if (partner?.logo) {
      logo = partner.logo;
    }

    // Company users never shows the default logo
    if (company) {
      return logo;
    }

    return logo || this.defaultLogo;
  }

  logout(): void {
    this.authenticationService.logout();
    this.router.navigate(["/logout"]);
  }

  showComponent(path: string): boolean {
    return !environment.disabledPaths.some((disabledPath) => path.includes(disabledPath));
  }

  toggleSettingsDropdown(event: any) {
    event.stopPropagation();
    this.showSettingsDropdown = !this.showSettingsDropdown;
  }

  shouldShowMaintenanceProvider() {
    return this.currentUser.isGlobal() && !this.currentUser.isCWRep;
  }

  shouldShowSettings() {
    return this.currentUser.isGlobal();
  }

  mouseEnter(trigger, item?: any) {
    /* To close opened menu when another dropdown is opened */
    if (this.triggerMenu && this.triggerMenu != trigger) {
      this.triggerMenu.closeMenu();
    }
    if (this.timedOutCloser) {
      clearTimeout(this.timedOutCloser);
    }
    trigger.openMenu();
    /* to remove the automatic focus on the first menu item after having selected the trigger button (ex. after clicking) */
    if (item) {
      this.ren.removeClass(item["_elementRef"].nativeElement, "cdk-focused");
      this.ren.removeClass(item["_elementRef"].nativeElement, "cdk-program-focused");
    }
    this.triggerMenu = trigger;
  }

  mouseLeave(trigger, button?: any) {
    this.timedOutCloser = setTimeout(() => {
      trigger.closeMenu();
      /* to remove the automatic focus on the menu trigger button after hovering other element */
      this.ren.removeClass(button["_elementRef"].nativeElement, "cdk-focused");
      this.ren.removeClass(button["_elementRef"].nativeElement, "cdk-program-focused");
    }, 100);
  }
}
